import { Auth0Plugin, createAuth0 } from '@auth0/auth0-vue'
import * as auth0 from 'auth0-js'
import { getSessionToken } from '@/modules/auth/hooks/useSession'
export const UNAUTHENTICATED_ROUTES: string[] = ['/signup', '/invite', '/auth', '/error']

export const routeNeedsAuthentication = (path: string) => {
  return !(UNAUTHENTICATED_ROUTES.some((it) => path.startsWith(it)));
}

export const needsAuthentication = () => {
  return routeNeedsAuthentication(window.location.pathname);
}

export const shouldBeLoggedin = () => needsAuthentication();

const domain = import.meta.env?.VITE_APP_AUTH0_DOMAIN || ''
const client_id = import.meta.env?.VITE_APP_AUTH0_CLIENT_ID || ''
// API identifier the backend's JWT middleware verifies the `aud` claim
// against. Without it set, Auth0 issues opaque access tokens with no
// audience binding. (DEV-4464)
export const AUDIENCE = import.meta.env?.VITE_APP_AUTH0_AUDIENCE || ''

if (!AUDIENCE && import.meta.env?.PROD) {
  // Loud warning, not a throw — throwing here would brick app boot and the
  // failure surfaces clearly enough as 401s once the backend verifies the
  // aud claim. Catches the case where Amplify env vars regress without
  // anyone noticing until users start seeing login failures.
  console.error(
    '[auth] VITE_APP_AUTH0_AUDIENCE not set — access tokens will be opaque ' +
    'and rejected once the backend enforces audience verification.',
  )
}

export const Auth0Service: Auth0Plugin = createAuth0({
  domain: domain as string,
  clientId: client_id as string,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: AUDIENCE,
  },
  legacySameSiteCookie: false,
  cacheLocation: 'localstorage'
})

export const webAuth = new auth0.WebAuth({
  clientID: client_id,
  domain: domain,
  audience: AUDIENCE,
  leeway: 10
})

export const hasSession =  () => {
  return !!getSessionToken();
}

export const getToken = async (): Promise<string | undefined> => {
  return getSessionToken();
}
